import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { create } from 'zustand/react';

type KEY = 'eggs_vault_on' | 'eggs_vault_banner_on';

interface ExternalToken {
  remoteConfig: Record<KEY, string>;
  setRemoteConfig: (key: KEY, value: string) => void;
  showAds: {
    bannerBoottom: boolean;
  };
  closeAds: (key: string, value: boolean) => void;
}

export const useFirebaseStore = create<ExternalToken>()(
  immer(
    persist(
      (set) => ({
        remoteConfig: {
          eggs_vault_on: '0',
          eggs_vault_banner_on: '0',
        },
        showAds: {
          bannerBoottom: true,
        },
        setRemoteConfig: (key, value) => {
          set((state) => {
            if (key === 'eggs_vault_on') {
              state.remoteConfig.eggs_vault_on = value;
            }

            if (key === 'eggs_vault_banner_on') {
              state.remoteConfig.eggs_vault_banner_on = value;
            }
          });
        },
        closeAds: (key, value) => {
          set((state) => {
            if (key === 'bannerBoottom') {
              state.showAds.bannerBoottom = value;
            }
          });
        },
      }),
      {
        name: 'remoteConfig',
      },
    ),
  ),
);
